import Content from '../../elements/search/searchContent';
import Description from '../../elements/search/searchDescription';
import Message from '../../atoms/text/searchMessage';
import Context, {
  Props as ContextProps,
} from '../../../../shared/components/utils/context/mainContext';
import { useEffect, useState } from 'react';
import SearchMask from '@components/atoms/container/searchMask';
import Focus from '@shared/types/enums/focus';
import FocusUtils from '@shared/utils/focus';

interface Props {
  context: ContextProps;
  message: string;
  searching: boolean;
  input?: string;
}

function SearchResults({ context, message, searching, input }: Props) {
  const { asset, rails } = context;
  const [display, setDisplay] = useState(false);

  useEffect(() => {
    if (rails?.length) {
      setTimeout(() => {
        setDisplay(true);
      });
    }
  }, [rails]);

  return (
    <>
      {display && rails?.length ? (
        <Context.Provider value={context}>
          <SearchMask
            hide={
              (input?.length || 0) > 0 &&
              !FocusUtils.evaluateFocus(Focus.RAILS_LIST)
            }
          >
            {!searching ? <Content rails={rails} /> : <></>}
          </SearchMask>
          <Description asset={asset} />
        </Context.Provider>
      ) : null}
      ;{message ? <Message searching={searching}>{message}</Message> : null}
    </>
  );
}

export default SearchResults;
